import { IconButton } from '@mui/material';
import { VyIcon } from '@weft/icons';
import { Dropdown } from 'antd';
import { useSwallowClick } from '../../../../hooks/use-swallow-click';
import { getProductDotMenuItems } from '../create-plan-page-consts/product-dot-menu-consts';

type ProductDotMenuDropdownProps = { 
  onCreateGroup: () => void;
  onDeleteGroup: () => void;
  isGrouped: boolean;
};

export default function ProductDotMenuDropdown({ onCreateGroup, onDeleteGroup, isGrouped }: ProductDotMenuDropdownProps) {
  const swallowClick = useSwallowClick();

  function handleGroupingClick() {
    if (isGrouped) {
      onDeleteGroup();
    } else {
      onCreateGroup();
    }
  }

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items: getProductDotMenuItems({ isGrouped }), onClick: handleGroupingClick }}
    >
      <IconButton onClick={swallowClick}>
        <VyIcon icon="DotsMenu"/>
      </IconButton>
    </Dropdown>
  );
}